import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center px-3 mt-4 gap-2" }

import DesktopSearchBar from "@/vue/planning/components/search/DesktopSearchBar.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'DataFilter',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DesktopSearchBar)
  ]))
}
}

})